import { Box, type BoxProps } from "@hightouch/htui";
import type { FC } from "react";

import { CopyButton } from "src/components/copy-button";
import { Editor, type Language } from "src/components/editor";

type Props = {
  value: string;
  language?: Language;
  showLineNumbers?: boolean;
  bg?: BoxProps["bg"];
};

export const CodeBlock: FC<Readonly<Props>> = ({
  value,
  language,
  showLineNumbers,
  bg,
}) => (
  <Box
    position="relative"
    sx={{
      "& > .copy-overlay": {
        opacity: 0,
        transitionProperty: "common",
        transitionDuration: "fast",
      },
      "&:hover > .copy-overlay": { opacity: 1 },
    }}
  >
    <Editor
      value={value}
      minHeight="20px"
      readOnly
      language={language}
      showLineNumbers={showLineNumbers}
      bg={bg}
    />
    <Box className="copy-overlay" position="absolute" top={1} right={1}>
      <CopyButton value={value} size="md" />
    </Box>
  </Box>
);
